import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import OrderCard from "@/components/OrderCard";
import { Package } from "lucide-react";
import { logger } from "@/lib/logger";

export default function Orders() {
  const { user } = useAuth();
  const [tab, setTab] = useState(user?.role === "seller" ? "accepted" : "mine");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/orders?scope=${tab}`);
      setOrders(data);
    } catch (err) {
      logger.error("orders: failed to load", err);
    }
    setLoading(false);
  }, [tab]);

  useEffect(() => {
    load();
    const iv = setInterval(load, 15000);
    return () => clearInterval(iv);
  }, [load]);

  if (!user) return null;

  const tabs = user.role === "seller"
    ? [
        { v: "feed", l: "Feed" },
        { v: "accepted", l: "Aceitos por mim" },
      ]
    : [
        { v: "mine", l: "Meus pedidos" },
      ];

  return (
    <div className="max-w-3xl mx-auto px-4 py-6 pb-24">
      <h1 className="font-heading font-black text-3xl md:text-4xl tracking-tight mb-6 flex items-center gap-2">
        <Package size={28} className="text-primary" /> Pedidos
      </h1>

      <div className="flex gap-1 bg-secondary p-1 rounded-xl mb-4 w-fit">
        {tabs.map((t) => (
          <button
            key={t.v}
            data-testid={`orders-tab-${t.v}`}
            onClick={() => setTab(t.v)}
            className={`px-4 py-2 rounded-lg text-sm font-medium ${
              tab === t.v ? "bg-background shadow-sm" : "text-muted-foreground"
            }`}
          >
            {t.l}
          </button>
        ))}
      </div>

      {loading && orders.length === 0 ? (
        <p className="text-muted-foreground py-12 text-center">Carregando...</p>
      ) : orders.length === 0 ? (
        <div className="text-center py-12 border border-dashed border-border rounded-xl">
          <p className="text-muted-foreground">Nenhum pedido nesta lista</p>
        </div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => (
            <OrderCard key={o.order_id} order={o} />
          ))}
        </div>
      )}
    </div>
  );
}
